<template>
  <div :class="type">
    <BaseModal
      v-model="gdq_recertification"
      size="lg"
      @hidden="recertify_redirect"
    >
      <div v-html="gdq_recertification_text" />
    </BaseModal>

    <nav
      class="navbar navbar-expand-lg navbar-dark sticky-top container-xl mx-auto align-items-center ps-1 pe-3"
    >
      <router-link to="/" class="navbar-brand">
        <h1 class="item-text">
          <Logo />
        </h1>
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#nav-collapse"
        aria-controls="nav-collapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="nav-collapse">
        <!-- Right aligned nav items -->
        <ul class="navbar-nav ms-auto ps-1 me-3">
          <li
            class="nav-item dropdown normal-dropdown"
            :class="{ show: resourcesOpen }"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="resourcesDropdown"
              role="button"
              :aria-expanded="resourcesOpen"
              @click.prevent="toggleResources"
            >
              Resources
            </a>
            <ul
              class="dropdown-menu"
              :class="{ show: resourcesOpen }"
              aria-labelledby="resourcesDropdown"
              @click="resourcesOpen = false"
            >
              <li>
                <router-link
                  to="/tutorials"
                  class="dropdown-item"
                  :class="{
                    disabled:
                      consultantstatus &&
                      consultantstatus.can_do_survey === '0',
                  }"
                >
                  Tutorials
                </router-link>
              </li>
              <li v-if="is_consultant">
                <router-link
                  to="/consultantmaterials"
                  class="dropdown-item"
                  :class="{
                    disabled:
                      consultantstatus &&
                      consultantstatus.can_do_survey === '0',
                  }"
                >
                  Materials for Practitioners
                </router-link>
              </li>
              <li v-if="is_admin">
                <router-link
                  to="/adminmaterials"
                  class="dropdown-item"
                  :class="{
                    disabled:
                      consultantstatus &&
                      consultantstatus.can_do_survey === '0',
                  }"
                >
                  Admin Materials
                </router-link>
              </li>
              <li v-if="is_tot">
                <a
                  href="/totmaterials"
                  class="dropdown-item"
                  :class="{
                    disabled:
                      consultantstatus &&
                      consultantstatus.can_do_survey === '0',
                  }"
                >
                  ToT Materials
                </a>
              </li>
              <li v-if="faqs">
                <a
                  href="/faq"
                  class="dropdown-item"
                  :class="{
                    disabled:
                      consultantstatus &&
                      consultantstatus.can_do_survey === '0',
                  }"
                >
                  FAQ
                </a>
              </li>
              <li v-if="faqs">
                <a
                  href="https://gdq.se/en/privacypolicy/"
                  class="dropdown-item"
                  :class="{
                    disabled:
                      consultantstatus &&
                      consultantstatus.can_do_survey === '0',
                  }"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Legal & Privacy
                </a>
              </li>
            </ul>
          </li>

          <li class="nav-item">
            <a
              href="https://gdq.se/en/contact/"
              class="nav-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Support
            </a>
          </li>

          <li class="nav-item">
            <a href="#" class="nav-link" @click.prevent="messages_show">
              Notifications
              <span v-if="unreadmessages > 0" class="noti-circle">{{
                unreadmessages
              }}</span>
            </a>
          </li>

          <li
            class="nav-item dropdown name-dropdown"
            :class="{ show: userOpen }"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="userDropdown"
              role="button"
              :aria-expanded="userOpen"
              @click.prevent="toggleUser"
            >
              {{ user.first_name }} {{ user.family_name }}
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end"
              :class="{ show: userOpen }"
              aria-labelledby="userDropdown"
              @click="userOpen = false"
            >
              <li v-if="is_consultant">
                <router-link to="/" class="dropdown-item text-primary">
                  <i class="fa-regular fa-gauge"></i> Dashboard
                </router-link>
              </li>
              <li v-if="is_consultant && teamdashboard_visible">
                <router-link to="/teamdashboard" class="dropdown-item">
                  <i class="fa-regular fa-users"></i> My Teams
                </router-link>
              </li>
              <li v-if="is_consultant">
                <router-link to="/profile" class="dropdown-item">
                  <i class="fa-regular fa-user"></i> My Profile
                </router-link>
              </li>
              <!-- <li v-if="is_consultant">
                <router-link :to="`/consultantmailpreferences/${profile.subscription_token}`" class="dropdown-item">
                  <i class="fa-regular fa-envelope"></i> Mail Preferences
                </router-link>
              </li> -->
              <li v-if="is_consultant">
                <router-link to="/surveys" class="dropdown-item">
                  <i class="fa-regular fa-square-poll-vertical"></i> My Surveys
                </router-link>
              </li>
              <li v-if="is_admin">
                <a :href="admin_url" class="dropdown-item">
                  <i class="fa-regular fa-user-cog"></i> Admin
                </a>
              </li>
              <li v-if="asadmin === 1">
                <a href="#" class="dropdown-item" @click.prevent="toggleanon">
                  <i
                    class="fa-regular"
                    :class="anon ? 'fa-eye' : 'fa-eye-slash'"
                  ></i>
                  {{ anon ? 'Show all' : 'Anonymize' }}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  class="dropdown-item text-danger"
                  @click.prevent="logout"
                >
                  Log out
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
    <BaseModal v-model="showmessages" title="System Messages" size="lg" ok-only>
      <div v-for="message in messagesmenu" :key="message.id" class="ps-4">
        <div
          class="row col-12 mb-1 py-1"
          :class="'bg-' + messagevariants[message.message_severity]"
          style="cursor: pointer"
          @click.prevent="message_show(message.id)"
        >
          <span class="gdq-w-50px pt-1">
            <span
              :title="
                message.status === 'read' ? 'Set as unread' : 'Set as read'
              "
              @click.prevent.stop="
                message_setstatus(
                  message.id,
                  message.status === 'read' ? 'unread' : 'read'
                )
              "
            >
              <fa-icon
                :icon="message.status === 'read' ? 'envelope-open' : 'envelope'"
                class="me-2 mt-0"
              />
            </span>
            <fa-icon
              :icon="
                Number(showingmessage) === Number(message.id)
                  ? 'chevron-down'
                  : 'chevron-right'
              "
              class="me-2 mt-0"
            />
          </span>
          <span class="gdq-w-50px pt-1">
            {{ message.message_activation_date }}
          </span>
          <span class="pt-1">
            {{ message.message_heading }}
          </span>
        </div>
        <div
          v-show="Number(showingmessage) === Number(message.id)"
          v-html="message.message_message"
        />
      </div>
    </BaseModal>

    <BaseModal
      v-model="showmain"
      size="lg"
      title="Messages from GDQ Associates"
      ok-only
    >
      <div
        v-for="message in messagesmain"
        :key="message.id"
        class="alert"
        :class="'alert-' + messagevariants[message.message_severity]"
      >
        <h3>{{ message.message_heading }}</h3>
        <span v-html="message.message_message" />
      </div>
      <template #modal-footer>
        <div class="form-check">
          <input
            id="dontshowmotd"
            v-model="dontshowmotd"
            type="checkbox"
            class="form-check-input"
          />
          <label for="dontshowmotd" class="form-check-label">
            Don't show this message again
          </label>
        </div>
        <button class="btn btn-secondary" @click.prevent="main_close()">
          OK
        </button>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { config } from "../../config";
import Logo from "./Logo.vue";
import BaseModal from "./base/BaseModal.vue";

export default {
  name: "Navbar",
  components: {
    Logo,
    BaseModal,
  },
  props: {
    type: {
      type: String,
      default: "bg-primary",
    },
  },
  setup(props) {
    // Store and router
    const store = useStore();
    const router = useRouter();

    // Reactive data
    const anon = computed(() => store.state.anon);
    const teamdashboard_visible = computed(() => true);
    const asadmin = ref(store.state.asadmin);
    const user = ref(store.state.user);
    const profile = ref(store.state.profile);
    const gdqmodeclass = ref("bg-primary");
    const search = ref("");
    const is_consultant = ref(false);
    const is_tot = ref(false);
    const is_admin = ref(false);
    const lastlogin_months = ref(0);
    const gdq_recertification_months = ref(1000);
    const gdq_recertification_text = ref("");
    const gdq_recertification = ref(false);
    const faqs = ref(false);
    const messagesmenu = ref([]);
    const messagesmain = ref([]);
    const showmessagesicon = ref(false);
    const showmessages = ref(false);
    const showmain = ref(false);
    const showingmessage = ref(0);
    const unreadmessages = ref(0);
    const dontshowmotd = ref(false);
    const nowdate = ref(new Date().toISOString().substring(0, 10));
    const resourcesOpen = ref(false);
    const userOpen = ref(false);

    // Message variants
    const messagevariants = ["", "", "", "warning", "danger"];

    // Computed properties
    const admin_url = computed(() => {
      return config.front_url.replace("markii", "admin");
    });

    const consultantstatus = computed({
      get() {
        if (!store.state.consultantstatuses) return null;
        return store.state.consultantstatuses.find(
          (s) => s.id === profile.value.consultantstatus_id
        );
      },
      set(val) {
        if (val) {
          store.commit("profile_set", {
            ...store.state.profile,
            consultantstatus_id: val.id,
          });
        }
      },
    });

    // Methods
    const toggleResources = () => {
      resourcesOpen.value = !resourcesOpen.value;
      userOpen.value = false;
    };

    const toggleUser = () => {
      userOpen.value = !userOpen.value;
      resourcesOpen.value = false;
    };

    const handleClickOutside = (event) => {
      if (event.target.closest(".navbar") === null) {
        resourcesOpen.value = false;
        userOpen.value = false;
      }
    };

    const user_get = async () => {
      await store.dispatch("user_fetch").then(() => {
        user.value = store.state.user;
      });
    };

    const profile_get = async () => {
      await store.dispatch("profile_fetch", {}).then(() => {
        console.log(store.state.profile.id);
        profile.value = store.state.profile;
      });
    };

    const consultantstatus_set = () => {
      return store.dispatch("consultantstatuses_fetch").then(() => {
        if (!store.state.consultantstatuses) return;
        const status = store.state.consultantstatuses.find(
          (s) => s.id === profile.value.consultantstatus_id
        );
        if (status) {
          consultantstatus.value = status;
        }
      });
    };

    const toggleanon = () => {
      store.dispatch("toggleanon");
    };

    const recertify_redirect = () => {
      router.push("/login");
    };

    const check_oldlogin = () => {
      lastlogin_months.value = 0;
      if (user.value.prev_login !== null) {
        const d1 = new Date(user.value.prev_login.replace(" ", "T"));
        const d2 = new Date();
        let months = 0;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth() + 1;
        months += d2.getMonth() + 1;
        lastlogin_months.value = months;
        store
          .dispatch("syspref_get", { name: "gdq_recertification_months" })
          .then((resp) => {
            gdq_recertification_months.value = resp.data.value;
            if (
              parseInt(lastlogin_months.value) >=
              parseInt(gdq_recertification_months.value)
            ) {
              store
                .dispatch("syspref_get", { name: "gdq_recertification_text" })
                .then((resp) => {
                  gdq_recertification_text.value = resp.data.value;
                  gdq_recertification.value = true;
                });
            }
          });
      }
    };

    const main_close = () => {
      showmain.value = false;
      if (dontshowmotd.value === true && messagesmain.value) {
        for (let i = 0; i < messagesmain.value.length; i++) {
          message_setstatus(messagesmain.value[i].id, "read");
        }
      }
    };

    const messages_show = () => {
      showmessages.value = true;
      showingmessage.value = 0;
    };

    const message_show = (message_id) => {
      showingmessage.value =
        showingmessage.value === message_id ? 0 : message_id;
      if (showingmessage.value !== 0) {
        message_setstatus(showingmessage.value, "read");
      }
    };

    const messages_get = () => {
      store
        .dispatch("usersystemmessages_fetch", { user_id: store.state.user_id })
        .then((resp) => {
          messagesmenu.value = resp.data.result || [];
          showmessagesicon.value = messagesmenu.value.length > 0;
          const unreadlist = messagesmenu.value.filter(
            (m) => m.status === "unread"
          );
          unreadmessages.value = unreadlist.length;
          messagesmain.value = messagesmenu.value.filter(
            (m) => m.status === "unread" && Number(m.always_show) === 1
          );
          showmain.value =
            messagesmain.value.length > 0 &&
            router.currentRoute.value.path === "/";
        });
    };

    const message_setstatus = (message_id, status) => {
      store
        .dispatch("usersystemmessage_setstatus", {
          user_id: store.state.user_id,
          message_id,
          message_status: status,
        })
        .then(() => {
          messages_get();
        });
    };

    const logout = function () {
      store
        .dispatch("logout", {})
        .then(() => router.push("/login"))
        // eslint-disable-next-line
        .catch((err) => console.log(err));
    };

    const user_role_set = () => {
      if (!store.state.user_usergroups) return;
      for (let i = 0; i < store.state.user_usergroups.length; i++) {
        if (Number(store.state.user_usergroups[i].usergroup_id) === 1) {
          is_consultant.value = true;
        }
        if (Number(store.state.user_usergroups[i].usergroup_id) === 2) {
          is_admin.value = true;
        }
        if (Number(store.state.user_usergroups[i].usergroup_id) === 8) {
          is_tot.value = true;
        }
      }
    };

    const user_status_set = () => {
      // Empty function
    };

    const faqs_get = () => {
      store
        .dispatch("records_readall", { table_name: "g_faq" })
        .then((resp) => {
          if (resp.data.result && resp.data.result.length > 0) {
            faqs.value = true;
          }
        });
    };

    // Lifecycle hooks
    onMounted(() => {
      document.addEventListener("click", handleClickOutside);

      // Initialize component data
      user_get().then(() => {
        profile_get().then(() => {
          messages_get();
          faqs_get();
          const groupsReady =
            !store.state.user_usergroups ||
            store.state.user_usergroups.length === 0
              ? store.dispatch("user_usergroups_fetch")
              : Promise.resolve();
          groupsReady.then(() => {
            consultantstatus_set().then(() => {
              user_role_set();
            });
          });
        });
      });
    });

    onUnmounted(() => {
      document.removeEventListener("click", handleClickOutside);
    });

    return {
      // Data
      anon,
      teamdashboard_visible,
      asadmin,
      user,
      profile,
      gdqmodeclass,
      search,
      is_consultant,
      is_tot,
      is_admin,
      lastlogin_months,
      gdq_recertification_months,
      gdq_recertification_text,
      gdq_recertification,
      faqs,
      messagesmenu,
      messagesmain,
      showmessagesicon,
      showmessages,
      showmain,
      showingmessage,
      unreadmessages,
      dontshowmotd,
      config,
      messagevariants,
      nowdate,
      resourcesOpen,
      userOpen,

      // Computed
      admin_url,
      consultantstatus,

      // Methods
      toggleResources,
      toggleUser,
      user_get,
      profile_get,
      consultantstatus_set,
      toggleanon,
      recertify_redirect,
      check_oldlogin,
      main_close,
      messages_show,
      message_show,
      messages_get,
      message_setstatus,
      logout,
      user_role_set,
      user_status_set,
      faqs_get,
    };
  },
};
</script>

<style scoped>
a.nav-link {
  color: white !important;
}

a.nav-link.dropdown-toggle {
  color: white !important;
}

.dropdown.show > a.nav-link.dropdown-toggle {
  color: black !important;
}

.dropdown-item.disabled {
  pointer-events: none;
  opacity: 0.6;
}

.noti-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #dc3545;
  color: white;
  border-radius: 50%;
  width: 1.35rem;
  height: 1.35rem;
  font-size: 0.7rem;
  font-weight: 600;
  margin-left: 4px;
  position: relative;
  top: -2px;
  left: -2px;
}

.navbar {
  display: flex;
  align-items: center;
  padding-left: 0.25rem;
  padding-right: 1.25rem;
}

.navbar-brand {
  display: flex;
  align-items: center;
}

.navbar .nav-link,
.navbar .dropdown-menu .dropdown-item {
  font-size: 18px !important;
}

.navbar-brand .item-text {
  margin: 0;
  display: flex;
  align-items: center;
  line-height: 1;
}

.navbar-collapse,
.navbar-nav {
  display: flex;
  align-items: center;
}

.navbar-collapse {
  flex: 1;
  justify-content: flex-end;
}
</style>
